module.exports = __webpack_public_path__ + "static/media/NEAR.66e39faa.svg";